import request from './request'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
    request
})

export default rootReducer